import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  const [displayText, setDisplayText] = useState('');
  const fullText = 'Turn Renting Into Equity';

  useEffect(() => {
    let i = 0;
    const typeWriter = () => {
      if (i < fullText.length) {
        setDisplayText(fullText.slice(0, i + 1));
        i++;
        setTimeout(typeWriter, 100);
      }
    };
    
    const timer = setTimeout(typeWriter, 1000);
    return () => clearTimeout(timer);
  }, []);

  const openWaitlist = () => {
    document.getElementById('waitlistModal').style.display = 'block';
    document.body.style.overflow = 'hidden';
  };

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="floating-money money-1">💰</div>
      <div className="floating-money money-2">🏠</div>
      <div className="floating-money money-3">📈</div>
      
      <div className="hero-inner container">
        <div className="hero-content">
          <motion.h1 
            className="migra-font"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            {displayText}
          </motion.h1>
          
          <motion.p 
            className="subtitle"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.5 }}
          >
            The Real Estate Stock Market for Everyone
          </motion.p>
          
          <motion.p 
            className="description"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 2 }}
          >
            Stop throwing money away on rent. Build real estate wealth with just 5% of your monthly rent payment through our revolutionary mobile platform.
          </motion.p>
          
          <motion.div 
            className="hero-cta"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 3 }}
          >
            <button className="cta-primary" onClick={openWaitlist}>
              🚀 Start Building Wealth
            </button>
            <button className="cta-secondary" onClick={() => scrollToSection('how-it-works')}>
              📖 Learn How It Works
            </button>
          </motion.div>
        </div>
      </div>
      
      <div className="hero-houses">
        <div className="house"></div>
        <div className="house"></div>
        <div className="house"></div>
      </div>
    </section>
  );
};

export default Hero;